import { IReduxStore } from "Redux/Store/IReduxStore";
import { camelCaseToHigherCase } from "ClientService";

export const getServerOption = (state: IReduxStore, key: string, defaultValue: unknown = null) => {
    key = camelCaseToHigherCase(key);
    if(!state.persist.settings[key]) {
        return defaultValue;
    }
    return state.persist.settings[key];
}